import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = {
  title: 'Política de Privacidad',
  body: `Última actualización: marzo 2026

Tu privacidad es importante para nosotros. Esta política describe cómo recopilamos, usamos y protegemos tu información personal.

Información que recopilamos:
• Nombre y dirección de correo electrónico al realizar una compra.
• Información de pago procesada de forma segura a través de proveedores externos. No almacenamos datos de tarjetas de crédito.

Uso de la información:
• Para entregar el producto digital que adquiriste.
• Para enviarte actualizaciones relacionadas con tu compra.
• No vendemos, alquilamos ni compartimos tu información personal con terceros con fines de marketing.

Cookies:
• Utilizamos cookies esenciales para el funcionamiento del sitio y cookies analíticas para mejorar la experiencia del usuario.

Seguridad:
• Implementamos medidas de seguridad estándar de la industria para proteger tu información personal.

Tus derechos:
• Puedes solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento.

Al utilizar este sitio, aceptas los términos de esta política de privacidad.`
};
const termsContent = {
  title: 'Términos y Condiciones',
  body: `Última actualización: marzo 2026

Al acceder y utilizar este sitio web y adquirir nuestros productos, aceptas los siguientes términos y condiciones.

Producto digital:
• "El Protocolo de Conexión de 7 Días" es un producto digital en formato PDF que se entrega electrónicamente.
• El acceso se otorga inmediatamente después de completar la compra.

Uso permitido:
• El contenido es para uso personal y familiar únicamente.
• No está permitido redistribuir, revender ni compartir el material sin autorización escrita.

Descargo de responsabilidad:
• Este producto es una herramienta educativa y de orientación. No sustituye el consejo médico, psicológico ni profesional.
• Si tu hijo está en crisis o peligro inmediato, contacta a los servicios de emergencia o la Línea Nacional de Prevención del Suicidio (988).

Política de reembolso:
• Debido a la naturaleza digital del producto, todas las ventas son finales. Si tienes algún problema con tu compra, contáctanos y haremos lo posible por ayudarte.

Limitación de responsabilidad:
• No garantizamos resultados específicos. Los resultados pueden variar según las circunstancias individuales de cada familia.

Modificaciones:
• Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán efectivos al publicarse en esta página.`
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const content = activeModal === 'privacy' ? privacyContent : termsContent;
  return <>
      <footer className="bg-navy-dark border-t border-white/10 py-8 px-4" data-id="element-28">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8" data-id="element-29">
          <button onClick={() => setActiveModal('privacy')} className="text-cream/60 hover:text-amber text-sm font-body transition-colors duration-200" data-id="element-30">
            Política de Privacidad
          </button>
          <span className="hidden sm:inline text-cream/30" data-id="element-31">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-cream/60 hover:text-amber text-sm font-body transition-colors duration-200" data-id="element-32">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-center text-cream/30 text-xs mt-4 font-body" data-id="element-33">
          © 2026 El Protocolo de Conexión de 7 Días. Todos los derechos
          reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-34">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-35">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-cream rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-36">
              <div className="flex items-center justify-between p-6 border-b border-charcoal/10" data-id="element-37">
                <h2 className="font-heading text-xl md:text-2xl text-navy font-bold" data-id="element-38">
                  {content.title}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-charcoal/50 hover:text-navy transition-colors p-1 rounded-lg hover:bg-charcoal/5" data-id="element-39">
                  <XIcon className="w-6 h-6" data-id="element-40" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-41">
                <div className="font-body text-charcoal text-base leading-relaxed whitespace-pre-line" data-id="element-42">
                  {content.body}
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}